class LogIn {
  toJson = (data) => ({
    email: data.email,
    password: data.password,
  });
}
export default LogIn;
